module.exports = __webpack_public_path__ + "static/img/rate.d8284c44.svg";